let ngInReactModule = angular.module('honeybook.ngInReact', ['ui.router', 'uuid4']);

function normalizeUrl(url) {
    const urlSplitted = url.split('?');
    const queryParamsString = urlSplitted[1];
    if (!queryParamsString) {
        return { url, path: urlSplitted[0] };
    }

    const queryParams = queryParamsString.split('&')
        .map(qp => qp.split('='))
        .filter(qps => qps.length === 2)
        .map(qps => qps.join('='))
        .join('&');
    const searchString = queryParams ? `?${queryParams}` : '';

    return { url: `${urlSplitted[0]}${searchString}`, path: urlSplitted[0] };
}

class NgInReactService {
    get isInIframe() {
        return window.top !== window.self;
    }

    constructor($state) {
        this.$state = $state;
        this.sessionId = undefined;
        this.onGlobalModalResolved = (data) => {};
        this.onGlobalModalRejected = () => {};
        window.addEventListener('message', e => {
            if (typeof e.data !== 'object') {
                return;
            }

            this.processMessage(e.data);
        });
    }

    init() {
        this.sendMessage('Loaded');
    }

    sendMessage(subject, payload) {
        window.parent.postMessage({ subject, sessionId: this.sessionId, payload }, '*');
    }

    sendUrlChange(_url, method) {
        if(!_url) {
            console.warn('send url ', method);
            this.sendMessage('Navigation', { method });
            return;
        }
        const { url, path } = normalizeUrl(_url);
        console.warn('send url ', url, path);
        this.sendMessage('Navigation', { url, path, method });
    }

    sendBusy(state) {
        this.sendMessage('Busy', { state });
    }

    processMessage(message) {
        if (message.subject !== 'SessionId' && message.subject !== 'setIsHBInAppBrowser' && (!this.sessionId || !message || message.sessionId !== this.sessionId)) {
            return;
        }

        switch (message.subject) {
            case 'SessionId':
                this.sessionId = message.payload.sessionId;
                break;
            case 'Navigation':
                this.navigate(message.payload);
                break;
            case 'GlobalModalResolved':
                this.onGlobalModalResolved(message.payload);
                break;
            case 'GlobalModalRejected':
                this.onGlobalModalRejected();
                break;
            case 'SwitchCompany':
                this.switchCompany(message.payload);
                break;
            case 'setIsHBInAppBrowser':
                // Flag received from React wrapper when the iframe is cross-origin.
                // We expose it globally so existing Angular code can check it.
                window.isHBInAppBrowser = true;
                break;
        }
    }

    navigate(routerState) {
        const path = routerState.path;
        this.$state.go(
            path,
            Object.assign({}, routerState.params),
            { reload: true, inherit: false, location: false }
        );
    }

    switchCompany(payload) {
        // Get Angular's AccountsService through dependency injection
        const injector = angular.element(document.body).injector();
        if (injector) {
            try {
                const AccountsService = injector.get('AccountsService');
                AccountsService.switchCompany(payload.companyId, payload.keepState).then(() => {
                    // Send acknowledgment that the company switch was successful
                    this.sendMessage('SwitchCompanyAck', {
                        companyId: payload.companyId,
                        success: true
                    });
                }).catch((error) => {
                    // Send acknowledgment that the company switch failed
                    this.sendMessage('SwitchCompanyAck', {
                        companyId: payload.companyId,
                        success: false
                    });
                });
            } catch (error) {
                // Send acknowledgment that the company switch failed
                this.sendMessage('SwitchCompanyAck', {
                    companyId: payload.companyId,
                    success: false
                });
            }
        } else {
            // Send acknowledgment that the company switch failed
            this.sendMessage('SwitchCompanyAck', {
                companyId: payload.companyId,
                success: false
            });
        }
    }
}

NgInReactService.$inject = ['$state'];
ngInReactModule.service('ngInReactService', NgInReactService);
